import { useDrop } from 'react-dnd';
import { Task } from '../interfaces/Task';

interface DroppableSectionProps {
    sectionId?: string;
    children: React.ReactNode;
    onDrop: (taskId: string, targetSectionId?: string) => void;
    className?: string;
}

export default function DroppableSection(props: DroppableSectionProps) {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: 'task',
        drop: (item: { taskId: string; currentSectionId?: string; task: Task }) => {
            if (item.currentSectionId !== props.sectionId) {
                props.onDrop(item.taskId, props.sectionId);
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }), [props.sectionId, props.onDrop]);

    const dropZoneStyle = {
        minHeight: '60px',
        backgroundColor: isOver && canDrop ? '#e3f2fd' : 'transparent',
        border: isOver && canDrop ? '2px dashed #2196f3' : '1px dashed transparent',
        borderRadius: '4px',
        transition: 'all 0.2s ease',
        position: 'relative' as const,
    };

    return (
        <div
            ref={drop as any}
            style={dropZoneStyle}
            className={props.className}
        >
            {props.children}
            {isOver && canDrop && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(33, 150, 243, 0.1)',
                    color: '#2196f3',
                    fontStyle: 'italic',
                    pointerEvents: 'none',
                    zIndex: 10
                }}>
                    Drop task here
                </div>
            )}
        </div>
    );
}